const COPY_ROOT = 'personality_results.refine_search'

export function personalityRefineSearchCopy(isApplicant) {
	const role = isApplicant ? 'applicant' : 'hiring_manager'
	const bulletPointCount = isApplicant ? 4 : 3

	return {
		heading: `${COPY_ROOT}.heading.${role}`,
		subheading: `${COPY_ROOT}.subheading.${role}`,
		firstColumnHeading: `${COPY_ROOT}.first_column.heading.${role}`,
		bulletPoints: Array.from(
			{ length: bulletPointCount },
			(_, index) =>
				`${COPY_ROOT}.first_column.bullet_point_${index + 1}.${role}`
		)
	}
}

export function personalityRetakeQuizLink(resourceId, isApplicant) {
	const path = isApplicant
		? `/assessment/applicant/${resourceId}`
		: `/assessment/job-offer/${resourceId}`

	const query = {
		mode: 'retake'
	}

	if (isApplicant) {
		query.redirect = `/applicant-profile/${resourceId}/edit/personality`
	}

	return {
		path,
		query
	}
}
